<!-- CustomInput.vue -->
<script>
import {store} from "../store.js";
import {useI18n} from "vue-i18n";
import {ref} from 'vue'
import * as EmailValidator from 'email-validator';

export default {
  setup() {
    const {t} = useI18n({useScope: 'global'})
    const select = ref(0)
    return {t, select}
  },
  props: {
    id: String,
    labelName: String,
    required: '',
    modelValue: String,
    step: '',
    inputType: String
  },
  data() {
    return {
      store,
      typeInput: '',
      errorMessage: ''
    }
  },
  emits: ['update:modelValue'],
  methods: {
    checkEmailValidity() {
      const email = this.$refs.emailInput.value;

      if (!email.includes('@')) return this.t('email.mustContainAt');
      if (email.includes(' ')) return this.t('email.noSpaces');

      const parts = email.split('@');
      if (parts.length !== 2 || parts[1].length === 0) return this.t('email.invalidDomain');
      if (!parts[1].includes('.')) return this.t('email.domainNeedsDot');

      const domainParts = parts[1].split('.');
      if (domainParts.some(part => part.length === 0)) return this.t('email.emptyDomainSegment');

      // Kontrola, zda má TLD správnou délku
      const tld = domainParts[domainParts.length - 1];
      if (tld.length < 2) return this.t('email.tldTooShort');

      return "";
    },
    handleInput(event) {
      const email = event.target.value;
      this.errorMessage = this.checkEmailValidity(email);
      this.$refs.emailInput.setCustomValidity(this.errorMessage);
    }
  },
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    isRequired() {
      if (this.required) {
        if (this.required.length > 0) return true;
      } else return false;
    },
    isBlurred() {
      if (this.step) {
        if (this.store.form.steps[this.step].blurred) return true; else return false;
      }
    },
    checkEmail() {
      var email = this.store.order.contactInfo.email;
      return EmailValidator.validate(email);
    },
  },
  mounted() {
  }


}
</script>

<template>
  <div class="form-label-group">
    <input v-if="!isRequired" ref="emailInput" type="email" :id="id" class="form-control" v-model="value"
           :placeholder="t(labelName)"/>
    <input v-if="isRequired" @input="handleInput" ref="emailInput" type="email" :id="id" class="form-control" v-model="value"
           :placeholder="t(labelName)"
           :class="{'is-invalid': isBlurred && isRequired && (!value || !checkEmail)}" required=""/>
    <label :for="id">
      <!--    Nazev v prekladu-->
      {{ t(labelName) }}</label>
    <div v-if="isRequired" class="invalid-feedback">
      <span v-if="!this.value">{{ t(required) }}</span>
      <span v-else-if="this.value && !checkEmail">
        {{ t('email.emailFormat') }}
        <br>
        {{ errorMessage }}
      </span>

    </div>

  </div>
</template>